<section class="title-bar content-padding first-item">
    <div class="wrapper">
        <h2 class="left">Change Timings</h2>
        <br class="clear">
    </div>
</section>

<section id="modificaConsegna" class="content-padding">
    <div class="narrow-wrapper">
        <form class="has-cols" [formGroup]="adminTimingForm" (ngSubmit)="onSubmit()" *ngIf="adminTimingForm">
            <div class="delivery-colle-data-box">
                <fieldset>
                    <legend>APPROVE TIMINGS FORM:</legend>

                    <div class="col-48 grid-element">
                        <label>CURRENT PICK UP TIME SLOT</label>
                        
                        <div class="time-range" [ngClass]="{'hidden': delivery?.isFlexblePickUpTime}">
                            <div>
                                <select formControlName="pickUpTime" [attr.disabled]="true">
                                    <option value="06:00-07:00">06:00-07:00</option>
                                    <option value="07:00-08:00">07:00-08:00</option>
                                    <option value="08:00-09:00">08:00-09:00</option>
                                    <option value="09:00-10:00">09:00-10:00</option>
                                    <option value="10:00-11:00">10:00-11:00</option>
                                    <option value="11:00-12:00">11:00-12:00</option>
                                    <option value="12:00-13:00">12:00-13:00</option>
                                    <option value="13:00-14:00">13:00-14:00</option>
                                    <option value="14:00-15:00">14:00-15:00</option>
                                    <option value="15:00-16:00">15:00-16:00</option>
                                    <option value="16:00-17:00">16:00-17:00</option>
                                    <option value="17:00-18:00">17:00-18:00</option>
                                    <option value="18:00-19:00">18:00-19:00</option>
                                    <option value="19:00-20:00">19:00-20:00</option>
                                    <option value="20:00-21:00">20:00-21:00</option>
                                    <option value="21:00-22:00">21:00-22:00</option>
                                </select>
                            </div>
                        </div>
                        
                        <div class="time-range" [ngClass]="{'hidden': !delivery?.isFlexblePickUpTime}">
                            <div>
                                <input type="time" [attr.disabled]="true">
                                <div *ngIf="approvedPickUpTTimeError" style="color: red; font-size: small;">Obbligatorio</div>
                            </div>
                            <div style="text-align: center;">&nbsp;-&nbsp;</div>
                            <div>
                                <input type="time" [attr.disabled]="true">
                                <div *ngIf="approvedPickUpFTimeError" style="color: red; font-size: small;">Obbligatorio</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-48 grid-element">
                        <label>New PICK UP TIME SLOT</label>

                        <div class="time-range" [ngClass]="{'hidden': delivery?.isFlexblePickUpTime}">
                            <div>
                                <select formControlName="approvedTimings">
                                    <option value="06:00-07:00">06:00-07:00</option>
                                    <option value="07:00-08:00">07:00-08:00</option>
                                    <option value="08:00-09:00">08:00-09:00</option>
                                    <option value="09:00-10:00">09:00-10:00</option>
                                    <option value="10:00-11:00">10:00-11:00</option>
                                    <option value="11:00-12:00">11:00-12:00</option>
                                    <option value="12:00-13:00">12:00-13:00</option>
                                    <option value="13:00-14:00">13:00-14:00</option>
                                    <option value="14:00-15:00">14:00-15:00</option>
                                    <option value="15:00-16:00">15:00-16:00</option>
                                    <option value="16:00-17:00">16:00-17:00</option>
                                    <option value="17:00-18:00">17:00-18:00</option>
                                    <option value="18:00-19:00">18:00-19:00</option>
                                    <option value="19:00-20:00">19:00-20:00</option>
                                    <option value="20:00-21:00">20:00-21:00</option>
                                    <option value="21:00-22:00">21:00-22:00</option>
                                </select>
                                <div *ngIf="adminTimingForm.get('approvedTimings').hasError('required') && adminTimingForm.get('approvedTimings').touched" style="color: red; font-size: small;">Obbligatorio</div>
                            </div>
                        </div>
                        
                        <div class="time-range" [ngClass]="{'hidden': !delivery?.isFlexblePickUpTime}">
                            <div>
                                <input type="time" [(ngModel)]="approvedPickUpFTime" [ngModelOptions]="{standalone: true}" (ngModelChange)="handlePickUpFlexbleTime()">
                                <div *ngIf="approvedPickUpFTimeError" style="color: red; font-size: small;">Obbligatorio</div>
                            </div>
                            <div style="text-align: center;">&nbsp;-&nbsp;</div>
                            <div>
                                <input type="time" [(ngModel)]="approvedPickUpTTime" [ngModelOptions]="{standalone: true}" (ngModelChange)="handlePickUpFlexbleTime()">
                                <div *ngIf="approvedPickUpTTimeError" style="color: red; font-size: small;">Obbligatorio</div>
                            </div>
                        </div>
                    </div>

                </fieldset>
            </div>
            <div class="center mt-20">
                <button 
                    class="btn hvr-shrink center" 
                    (click)="$event.preventDefault(); onSubmit()"
                    [disabled]="btnDisabled || !adminTimingForm.valid">
                    Salva
                    <i class="ml-10 far fa-save"></i>
                </button>
            </div>
        </form>
    </div>
</section>